export default class AddRecipientRequest {
  firstName?: string
  lastName?: string
  email!: string
}
